import {
    Button,
    createButtonComponent,
} from '@vfde-brix/button';

/**
 * Button component
 * @param container
 * @param onClick
 */
const mountButton = (container, onClick?): Button => {
    return createButtonComponent(container, {
        onClick,
    });
};

export default mountButton;
